// --------------------------------------------------------------------------
// Components of authentication page including their logical connections.
// --------------------------------------------------------------------------

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import { Box, Flex, Image, Button, FormControl, FormLabel, Input,
  Heading, useTheme, Text } from "@chakra-ui/react";
import { useAuth } from '../context/security';
import logo_emi from "./assets/emi_inverted.png";
import "./styles.css";


// --- BACKGROUND ---
function Background() {
  return(
    <Box className="background"></Box>
  );
};

const Copyright = () => {
  const theme = useTheme();
  
  return (
    <Box
      position="fixed"
      bottom="10px"
      right="10px"
      zIndex={0}>
      <Text
        color="black"
        fontSize={theme.fontSize.info}>
      </Text>
    </Box>
  );
};

// --- HEADER ---
function Header() {
  return(
  <Flex px={4} alignItems="center" className="header">
    <Image
      src={logo_emi} alt="Logo EMI"
      width="auto" height="70%"/>
  </Flex>
  );
};


// --- BODY ---
const Body: React.FC = () => {

  // 1. State, hooks, event handling and helper functions
  const theme = useTheme();
  const { setAuthToken } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = qs.stringify({
      username,
      password,
    });

    try {
      const response = await axios.post('/api/token',
        formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      const { access_token } = response.data;
      setAuthToken(access_token, username);
      navigate('/main'); 
    } catch (error) {
      alert('Login failed!');
    }
  };

  // 2. JSX
  return(
    <Box
      className="body-layout-column"
      display="flex" flexDirection="column"
      alignItems="center" justifyContent="center">
      <Box
        px={12} py={12}
        bg={theme.colors.main.box} 
        borderRadius={theme.radii.box}
        color={theme.colors.main.white}>
        <Heading
          mb={4}
          textAlign="center"
          fontSize={theme.fontSize.heading}>
          Please Log In
        </Heading>
        <form onSubmit={handleSubmit}>
          <FormControl id="username" isRequired>
            <FormLabel>Username</FormLabel>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}/>
          </FormControl>
          <FormControl id="password" isRequired mt={4}>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}/>
          </FormControl>
          <Button
            mt={8} width="100%"
            type="submit">
            Login
          </Button>
        </form>
      </Box>
    </Box>
  );
};

// --- EXPORT PAGE ---
const AuthPage = () => {
  return(
    <Box className="layout-column">
      <Header />
      <Body />
      <Background />
      <Copyright />
    </Box>
  );
};

export default AuthPage;